import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetProductionItemOrdersByShipWeekQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
  isoYear: Types.Scalars['Int']['input'];
  isoWeekStart: Types.Scalars['Int']['input'];
  isoWeekEnd: Types.Scalars['Int']['input'];
  productionItemIds?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;


export type GetProductionItemOrdersByShipWeekQuery = { __typename?: 'Query', productionItemOrdersByShipWeek: { __typename?: 'ProductionItemOrdersByShipWeekPayload', unmatchedOrderedEaches: number, noShipFromSiteOrderedEaches: number, rows: Array<{ __typename?: 'ProductionItemOrderedWeekRow', productionItemId: string, isoWeek: number, orderedEaches: number, orderedContainers: number }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type GetProductionItemOrderLinesByShipWeekQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
  productionItemId: Types.Scalars['String']['input'];
  isoYear: Types.Scalars['Int']['input'];
  isoWeek: Types.Scalars['Int']['input'];
}>;


export type GetProductionItemOrderLinesByShipWeekQuery = { __typename?: 'Query', productionItemOrderLinesByShipWeek: Array<{ __typename?: 'ProductionItemOrderLineData', orderId: string, orderNumber: string, customerName: string, poNumber: string, orderStatus: Types.OrderStatus, orderType: Types.OrderType, shipDateSource: Types.OrderShipWeekSource, shipDate: Types.TDateISO, lineNumber: number, orderedEaches: number, mixPct: number, counted: boolean, countedEaches: number, countedContainers: number }> };


export const GetProductionItemOrdersByShipWeekDocument = new TypedDocumentString(`
    query GetProductionItemOrdersByShipWeek($siteLocationId: String!, $isoYear: Int!, $isoWeekStart: Int!, $isoWeekEnd: Int!, $productionItemIds: [String!]) {
  productionItemOrdersByShipWeek(
    siteLocationId: $siteLocationId
    isoYear: $isoYear
    isoWeekStart: $isoWeekStart
    isoWeekEnd: $isoWeekEnd
    productionItemIds: $productionItemIds
  ) {
    rows {
      productionItemId
      isoWeek
      orderedEaches
      orderedContainers
    }
    unmatchedOrderedEaches
    noShipFromSiteOrderedEaches
    errors {
      code
      message
    }
  }
}
    `);
export const GetProductionItemOrderLinesByShipWeekDocument = new TypedDocumentString(`
    query GetProductionItemOrderLinesByShipWeek($siteLocationId: String!, $productionItemId: String!, $isoYear: Int!, $isoWeek: Int!) {
  productionItemOrderLinesByShipWeek(
    siteLocationId: $siteLocationId
    productionItemId: $productionItemId
    isoYear: $isoYear
    isoWeek: $isoWeek
  ) {
    orderId
    orderNumber
    customerName
    poNumber
    orderStatus
    orderType
    shipDateSource
    shipDate
    lineNumber
    orderedEaches
    mixPct
    counted
    countedEaches
    countedContainers
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetProductionItemOrdersByShipWeek: build.query<GetProductionItemOrdersByShipWeekQuery, GetProductionItemOrdersByShipWeekQueryVariables>({
      query: (variables) => ({ document: GetProductionItemOrdersByShipWeekDocument, variables })
    }),
    GetProductionItemOrderLinesByShipWeek: build.query<GetProductionItemOrderLinesByShipWeekQuery, GetProductionItemOrderLinesByShipWeekQueryVariables>({
      query: (variables) => ({ document: GetProductionItemOrderLinesByShipWeekDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetProductionItemOrdersByShipWeekQuery, useLazyGetProductionItemOrdersByShipWeekQuery, useGetProductionItemOrderLinesByShipWeekQuery, useLazyGetProductionItemOrderLinesByShipWeekQuery } = injectedRtkApi;
